import React, { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { chamarAdmin, mensagemDeErro } from "../../lib/adminApi";
import "./metricas.css";

// Página do link de convite (/admin/convite#<token>): a pessoa cria a própria senha e já entra.
// O token vem depois do "#", que o navegador nunca envia ao servidor nem a outros sites.
const DefinirSenha: React.FC = () => {
  const [, setLocation] = useLocation();
  const [token] = useState(() => window.location.hash.replace(/^#/, ""));
  const [convite, setConvite] = useState<{ nome: string; email: string } | null | undefined>(undefined);
  const [senha, setSenha] = useState("");
  const [repetida, setRepetida] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    // Tira o token da barra de endereço (e do histórico) assim que a página o leu.
    window.history.replaceState(null, "", window.location.pathname);
    if (!token) {
      setConvite(null);
      return;
    }
    chamarAdmin("/api/admin", { acao: "convite-ver", token })
      .then((r) => setConvite(r.ok ? (r.json as { nome: string; email: string }) : null))
      .catch(() => setConvite(null));
  }, [token]);

  const enviar = async () => {
    setErro(null);
    if (senha.length < 12) return setErro(mensagemDeErro("senha_curta"));
    if (senha !== repetida) return setErro("As senhas não conferem.");
    setEnviando(true);
    try {
      const r = await chamarAdmin("/api/admin", { acao: "convite-usar", token, senha });
      if (!r.ok) return setErro(mensagemDeErro(r.json?.erro));
      setLocation("/admin/metricas");
    } catch {
      setErro("Sem conexão com o servidor.");
    } finally {
      setEnviando(false);
    }
  };

  if (convite === undefined) return <div className="metricas-login" />;

  return (
    <div className="metricas-login">
      {convite ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            enviar();
          }}
        >
          <h1>Crie sua senha</h1>
          <p>
            Olá, {convite.nome.split(" ")[0]}! Este é o seu acesso ao painel interno da central de ajuda (
            {convite.email}).
          </p>
          <input
            type="password"
            autoComplete="new-password"
            autoFocus
            placeholder="Nova senha (mínimo 12 caracteres)"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
          <input
            type="password"
            autoComplete="new-password"
            placeholder="Repita a senha"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
          />
          {erro && <p className="metricas-erro">{erro}</p>}
          <button type="submit" disabled={enviando || !senha || !repetida}>
            {enviando ? "Salvando…" : "Criar senha e entrar"}
          </button>
        </form>
      ) : (
        <form onSubmit={(e) => e.preventDefault()}>
          <h1>Link inválido</h1>
          <p>{mensagemDeErro("convite")}</p>
        </form>
      )}
    </div>
  );
};

export default DefinirSenha;
